// extracted by mini-css-extract-plugin
module.exports = {"root":"QueueEmpty_root__3NIPu"};